export default {
  'courses.tooltips.title': 'Enter the title of the course you are creating.',
  'courses.tooltips.subtitle':
    'Enter the subtitle of the course you are creating to complement the title.',
  'courses.tooltips.summary': 'OBriefly and generally describe what your course will be about.',
  'courses.tooltips.description':
    'Add any description to your course, e.g. useful materials/vocabulary.',
  'courses.tooltips.active_from': 'Select your course start date.',
  'courses.tooltips.active_to': 'Select the end date of your course.',
  'courses.tooltips.level': 'Choose your course level.',
  'courses.tooltips.target_group': 'Select the target group of your course.',
  'courses.tooltips.duration': 'Specify the duration of your course in minutes.',
};
